(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2765],{

/***/ 89905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrowRightWhite(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 15.98 16"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.88 7.493a1.332 1.332 0 00-.28-.44L8.939.392a1.338 1.338 0 00-1.892 1.892l4.4 4.383H1.332a1.332 1.332 0 000 2.664h10.112l-4.4 4.383a1.338 1.338 0 101.895 1.89L15.6 8.945a1.377 1.377 0 00.28-1.452z",
    fill: "#fff"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRightWhite);

/***/ }),

/***/ 7339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ useWebV2FunnelEventOnce; },
/* harmony export */   "YO": function() { return /* binding */ useTrackWebV2FieldOnce; },
/* harmony export */   "fJ": function() { return /* binding */ getWebV2FunnelEvent; }
/* harmony export */ });
/* unused harmony export POSTING_STEP_PAGE_OPENED_EVENT */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69406);
/* harmony import */ var _compact_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90251);
/* harmony import */ var _compact_load_bidding_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65178);
/* harmony import */ var _compact_load_posting_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3970);







var WEB_V2 = _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_1__/* .GA4EventNames.WEB_V2 */ .wQ.WEB_V2;
var _obj;
/** Compact posting step → GA4 page-opened event name. */ var POSTING_STEP_PAGE_OPENED_EVENT = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _compact_load_posting_types__WEBPACK_IMPORTED_MODULE_4__/* .COMPACT_LOAD_POSTING_STEPS.ROUTE_DETAILS */ .M.ROUTE_DETAILS, WEB_V2.load_form_location_page_opened), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _compact_load_posting_types__WEBPACK_IMPORTED_MODULE_4__/* .COMPACT_LOAD_POSTING_STEPS.LOAD_DETAILS */ .M.LOAD_DETAILS, WEB_V2.load_form_spec_page_opened), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _compact_load_posting_types__WEBPACK_IMPORTED_MODULE_4__/* .COMPACT_LOAD_POSTING_STEPS.FREIGHT_QUOTE */ .M.FREIGHT_QUOTE, WEB_V2.load_form_price_page_opened), _obj);
function useWebV2FunnelEventOnce(trackEvent, eventData) {
    var firedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    var trackOnce = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(event, data) {
        if (firedRef.current[event]) {
            return;
        }
        firedRef.current[event] = true;
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(event, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, eventData, data));
    }, [
        eventData,
        trackEvent
    ]);
    var reset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        firedRef.current = {};
    }, []);
    /** Re-emit a funnel page-open after auth when the user returns to a step already deduped by `trackOnce`. */ var trackFunnelEventAfterAuth = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(event, data) {
        delete firedRef.current[event];
        trackOnce(event, data);
    }, [
        trackOnce
    ]);
    return {
        trackOnce: trackOnce,
        trackFunnelEventAfterAuth: trackFunnelEventAfterAuth,
        reset: reset
    };
}
/** Map compact flow step → WEB_V2 funnel page-open event. */ function getWebV2FunnelEvent(context) {
    if (context.flow === "posting") {
        if (context.step === _compact_load_posting_types__WEBPACK_IMPORTED_MODULE_4__/* .COMPACT_LOAD_POSTING_STEPS.LOGIN */ .M.LOGIN) {
            if (context.loginFormStep === _compact_auth__WEBPACK_IMPORTED_MODULE_2__/* .COMPACT_AUTH_STEPS.PHONE */ .Zz.PHONE) {
                return WEB_V2.login_sign_up_form_opened;
            }
            return undefined;
        }
        return context.step in POSTING_STEP_PAGE_OPENED_EVENT ? POSTING_STEP_PAGE_OPENED_EVENT[context.step] : undefined;
    }
    switch(context.step){
        case _compact_load_bidding_types__WEBPACK_IMPORTED_MODULE_3__/* .COMPACT_LOAD_BIDDING_STEPS.BID_DETAILS */ .n.BID_DETAILS:
            return context.showBookingSection ? WEB_V2.bid_form_detailed_opened : WEB_V2.bid_form_basic_opened;
        case _compact_load_bidding_types__WEBPACK_IMPORTED_MODULE_3__/* .COMPACT_LOAD_BIDDING_STEPS.LOGIN */ .n.LOGIN:
            if (context.loginFormStep === _compact_auth__WEBPACK_IMPORTED_MODULE_2__/* .COMPACT_AUTH_STEPS.PHONE */ .Zz.PHONE) {
                return WEB_V2.login_sign_up_form_opened;
            }
            return undefined;
        default:
            return undefined;
    }
}
function useTrackWebV2FieldOnce(trackEvent, eventData) {
    var firedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    var trackFieldOnce = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(dedupeKey, eventName, data) {
        if (firedRef.current[dedupeKey]) {
            return;
        }
        firedRef.current[dedupeKey] = true;
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(eventName, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, eventData, data));
    }, [
        eventData,
        trackEvent
    ]);
    var reset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        firedRef.current = {};
    }, []);
    return {
        trackFieldOnce: trackFieldOnce,
        reset: reset
    };
}


/***/ }),

/***/ 90251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zz": function() { return /* reexport */ COMPACT_AUTH_STEPS; },
  "cv": function() { return /* reexport */ compact_auth_CompactLoginFlow; },
  "tu": function() { return /* reexport */ getCompactAuthShellMeta; }
});

// UNUSED EXPORTS: CompactLoginQuoteSummary, useCompactAuth

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/icons/arrow-right-white.svg
var arrow_right_white = __webpack_require__(89905);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/constants/api.js
var api = __webpack_require__(24966);
// EXTERNAL MODULE: ../core-ui/dist/methods/index.js + 3 modules
var methods = __webpack_require__(38920);
// EXTERNAL MODULE: ./components/login-form-new/animate-container/AnimateContainer.tsx
var AnimateContainer = __webpack_require__(19115);
// EXTERNAL MODULE: ./components/login-form-new/hooks/auth/index.ts + 12 modules
var auth = __webpack_require__(22834);
// EXTERNAL MODULE: ./components/homepage-v2/compact-load-posting/hooks/useCompactLoadPostingTranslation.ts
var useCompactLoadPostingTranslation = __webpack_require__(62921);
// EXTERNAL MODULE: ./components/homepage-v2/compact-load-posting/LoadSummaryChip.tsx + 1 modules
var LoadSummaryChip = __webpack_require__(72892);
// EXTERNAL MODULE: ./services/lorry/useGetLorryMarketV2/useGetLorryMarketV2.ts
var useGetLorryMarketV2 = __webpack_require__(61167);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(42838);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core-ui/dist/components/OTPInput/index.js + 3 modules
var OTPInput = __webpack_require__(98276);
// EXTERNAL MODULE: ./components/login-form-new/common/contant.ts
var contant = __webpack_require__(20996);
// EXTERNAL MODULE: ./components/login-form-new/login-form-fields/otp-field/OtpField.tsx
var OtpField = __webpack_require__(8058);
// EXTERNAL MODULE: ./components/homepage-v2/hooks/useCompactSheetAutoFocus.ts
var useCompactSheetAutoFocus = __webpack_require__(77311);
// EXTERNAL MODULE: ./components/homepage-v2/methods/homepageV2CompactSheet.ts
var homepageV2CompactSheet = __webpack_require__(14199);
// EXTERNAL MODULE: ./components/homepage-v2/compact-auth/CompactOtpField.module.scss
var CompactOtpField_module = __webpack_require__(77255);
var CompactOtpField_module_default = /*#__PURE__*/__webpack_require__.n(CompactOtpField_module);
;// CONCATENATED MODULE: ./components/homepage-v2/compact-auth/CompactOtpField.tsx













var RESEND_BUFFER_SECONDS = 30;
var handleAuthFocus = (0,homepageV2CompactSheet/* createCompactSheetInputFocusHandler */.mJ)("auth");
function formatOtpDigits(otp) {
    return (otp !== null && otp !== void 0 ? otp : "").replace(/\D/g, "");
}
function formatPhoneDisplay(phone) {
    var digits = phone.replace(/\D/g, "");
    if (digits.length <= 5) {
        return digits;
    }
    return "".concat(digits.slice(0, 5), " ").concat(digits.slice(5));
}
var parseOtpValue = function(value) {
    return value.replace(/\D/g, "").slice(0, auth/* LOGIN_OTP_LENGTH */.tM);
};
var CompactOtpField = function(param) {
    var formik = param.formik, onClickResendOtp = param.onClickResendOtp, onClickEditNumber = param.onClickEditNumber, _otpSentToKey = param.otpSentToKey, otpSentToKey = _otpSentToKey === void 0 ? "load-form:login.otpSentTo" : _otpSentToKey, _compactBoxes = param.compactBoxes, compactBoxes = _compactBoxes === void 0 ? false : _compactBoxes, trackEvent = param.trackEvent;
    var t = (0,useCompactLoadPostingTranslation/* default */.Z)().t;
    var ref = (0,react.useState)(false), isResendingOtp = ref[0], setIsResendingOtp = ref[1];
    var otpWrapperRef = (0,react.useRef)(null);
    var wasSubmittingRef = (0,react.useRef)(false);
    var otpDigitCountRef = (0,react.useRef)(0);
    var ref1 = (0,auth/* useResendOtpTimer */.og)(RESEND_BUFFER_SECONDS), timeRemaining = ref1.timeRemaining, restartCountdown = ref1.restartCountdown;
    var resetAutoSubmit = (0,auth/* useOtpAutoSubmit */.r9)({
        formik: formik,
        onSubmit: function() {
            return formik.submitForm();
        }
    }).resetAutoSubmit;
    var otpDigitCount = formatOtpDigits(formik.values.otp).length;
    var showOtpError = Boolean(formik.errors.otp && otpDigitCount === auth/* LOGIN_OTP_LENGTH */.tM);
    var formattedPhone = formatPhoneDisplay(String(formik.values.phoneNumber));
    (0,useCompactSheetAutoFocus/* useCompactSheetRefAutoFocus */.f)(otpWrapperRef, 'input:not([type="hidden"])', {
        scrollIntoView: false
    });
    (0,react.useEffect)(function() {
        var wrapper = otpWrapperRef.current;
        if (!wrapper) {
            return;
        }
        var onFocusIn = function(event) {
            if (!(0,_instanceof/* default */.Z)(event.target, HTMLInputElement)) {
                return;
            }
            handleAuthFocus(event);
        };
        wrapper.addEventListener("focusin", onFocusIn);
        return function() {
            wrapper.removeEventListener("focusin", onFocusIn);
        };
    }, []);
    var applyOtpValue = function(value) {
        if (formik.errors.otp) {
            formik.setFieldError(contant/* loginFormFieldNames.otp */.H8.otp, undefined);
        }
        formik.setFieldValue(contant/* loginFormFieldNames.otp */.H8.otp, parseOtpValue(value));
    };
    var ref2 = (0,auth/* useSmsOtpAutofill */.YR)({
        onOtp: function(code) {
            var ref, ref1;
            (ref1 = (ref = otpWrapperRef.current) === null || ref === void 0 ? void 0 : ref.querySelector("input")) === null || ref1 === void 0 ? void 0 : ref1.blur();
            applyOtpValue(code);
        }
    }), startSmsOtpAutofill = ref2.startListening;
    (0,react.useEffect)(function() {
        otpDigitCountRef.current = otpDigitCount;
    }, [
        otpDigitCount
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var inputs = (ref = otpWrapperRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("input");
        inputs === null || inputs === void 0 ? void 0 : inputs.forEach(function(input) {
            return input.setAttribute("autocomplete", "one-time-code");
        });
    }, []);
    (0,react.useEffect)(function() {
        var submitJustFinished = wasSubmittingRef.current && !formik.isSubmitting;
        if (submitJustFinished && formik.errors.otp) {
            var ref;
            (ref = otpWrapperRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("input").forEach(function(input) {
                return input.blur();
            });
        }
        wasSubmittingRef.current = formik.isSubmitting;
    }, [
        formik.errors.otp,
        formik.isSubmitting
    ]);
    var onChangeOTP = function(value) {
        resetAutoSubmit();
        var nextDigitCount = value.replace(/\D/g, "").length;
        if (nextDigitCount > otpDigitCountRef.current) {
            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(event_names/* GA4EventNames.WEB_V2.otp_entered */.wQ.WEB_V2.otp_entered, {
                source_screen: event_names/* WEB_V2_SOURCE_SCREENS.ONB_FORM */.ZM.ONB_FORM,
                otp_length: nextDigitCount,
                Number: formik.values.phoneNumber
            });
        }
        otpDigitCountRef.current = nextDigitCount;
        applyOtpValue(value);
    };
    var showResendCountdown = timeRemaining > 0;
    var disableResendClick = showResendCountdown || isResendingOtp;
    var ref3 = (0,OtpField/* getTimeRemaining */.E)(timeRemaining), minutes = ref3.minutes, seconds = ref3.seconds;
    var resendLabel = "".concat(Number(minutes), ":").concat(seconds);
    var handleResend = function() {
        if (disableResendClick) {
            return;
        }
        resetAutoSubmit();
        restartCountdown();
        setIsResendingOtp(true);
        startSmsOtpAutofill();
        if (formik.errors.otp) {
            formik.setFieldError(contant/* loginFormFieldNames.otp */.H8.otp, undefined);
        }
        var pendingChannels = 2;
        var onChannelSettled = function() {
            pendingChannels -= 1;
            if (pendingChannels <= 0) {
                setIsResendingOtp(false);
            }
        };
        onClickResendOtp({
            onSuccessCallback: function() {},
            onSettledCallback: onChannelSettled
        });
        onClickResendOtp({
            isWhatsApp: true,
            onSuccessCallback: function() {},
            onSettledCallback: onChannelSettled
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((CompactOtpField_module_default()).field, compactBoxes && (CompactOtpField_module_default()).fieldCompact),
        children: [
            compactBoxes ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CompactOtpField_module_default()).numberChip,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (CompactOtpField_module_default()).numberChipValue,
                        children: [
                            "+91 ",
                            formattedPhone
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (CompactOtpField_module_default()).changeNumberBtn,
                        onClick: onClickEditNumber,
                        children: t("load-form:login.changeNumberShort")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (CompactOtpField_module_default()).sentTo,
                        children: t(otpSentToKey, {
                            phone: formattedPhone
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (CompactOtpField_module_default()).changeNumberBtn,
                        onClick: onClickEditNumber,
                        children: t("load-form:login.changeNumber")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (CompactOtpField_module_default()).label,
                children: t("load-form:login.otpLabel")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OTPInput/* default */.Z, {
                ref: otpWrapperRef,
                id: "compact-login-otp",
                length: auth/* LOGIN_OTP_LENGTH */.tM,
                value: formatOtpDigits(formik.values.otp),
                onChange: onChangeOTP,
                inputClassName: classnames_default()((CompactOtpField_module_default()).otpDigit, showOtpError && (CompactOtpField_module_default()).otpDigitError),
                containerClassName: (CompactOtpField_module_default()).otpContainer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (CompactOtpField_module_default()).resendRow,
                children: showResendCountdown ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        t("load-form:login.resendIn"),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (CompactOtpField_module_default()).resendTimer,
                            children: resendLabel
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: (CompactOtpField_module_default()).resendBtn,
                    onClick: handleResend,
                    disabled: isResendingOtp,
                    children: t("load-form:login.resendOtp")
                })
            })
        ]
    });
};
/* harmony default export */ var compact_auth_CompactOtpField = (CompactOtpField);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./components/homepage-v2/analytics/homepageV2WebAnalytics.ts
var homepageV2WebAnalytics = __webpack_require__(7339);
// EXTERNAL MODULE: ./components/homepage-v2/compact-auth/CompactPhoneNumberField.module.scss
var CompactPhoneNumberField_module = __webpack_require__(30518);
var CompactPhoneNumberField_module_default = /*#__PURE__*/__webpack_require__.n(CompactPhoneNumberField_module);
;// CONCATENATED MODULE: ./components/homepage-v2/compact-auth/CompactPhoneNumberField.tsx













var COMPACT_LOGIN_PHONE_INPUT_ID = "compact-login-phone";
var CompactPhoneNumberField_handleAuthFocus = (0,homepageV2CompactSheet/* createCompactSheetInputFocusHandler */.mJ)("auth");
var CompactPhoneNumberField = function(param) {
    var formik = param.formik, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, _layout = param.layout, layout = _layout === void 0 ? "default" : _layout, trackEvent = param.trackEvent;
    var t = (0,useCompactLoadPostingTranslation/* default */.Z)().t;
    var trackFieldOnce = (0,homepageV2WebAnalytics/* useTrackWebV2FieldOnce */.YO)(trackEvent, {
        source_screen: event_names/* WEB_V2_SOURCE_SCREENS.ONB_FORM */.ZM.ONB_FORM
    }).trackFieldOnce;
    var phoneValue = String(formik.values.phoneNumber || "");
    var hasError = Boolean(formik.touched.phoneNumber && formik.errors.phoneNumber);
    (0,useCompactSheetAutoFocus/* useCompactSheetAutoFocus */.v)(COMPACT_LOGIN_PHONE_INPUT_ID);
    var onChangePhoneNum = function(e) {
        e.target.value = (0,methods/* removeNonNumeric */.bI)(e.target.value.slice(0, auth/* LOGIN_PHONE_NUMBER_LENGTH */.kE));
        formik.handleChange(contant/* loginFormFieldNames.phoneNumber */.H8.phoneNumber)(e);
        if (e.target.value.length >= 1) {
            trackFieldOnce("phone", event_names/* GA4EventNames.WEB_V2.phone_number_entered */.wQ.WEB_V2.phone_number_entered, {
                Number: e.target.value
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((CompactPhoneNumberField_module_default()).field, layout === "inline" && (CompactPhoneNumberField_module_default()).fieldInline),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (CompactPhoneNumberField_module_default()).label,
                htmlFor: "compact-login-phone",
                children: t("load-form:login.mobileLabel")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CompactPhoneNumberField_module_default()).inputRow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((CompactPhoneNumberField_module_default()).countryCode, variant === "bid" && (CompactPhoneNumberField_module_default()).countryCodeBid),
                        "aria-hidden": true,
                        children: [
                            layout === "inline" ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (CompactPhoneNumberField_module_default()).flag,
                                children: "\uD83C\uDDEE\uD83C\uDDF3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (CompactPhoneNumberField_module_default()).dialCode,
                                children: "+91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: COMPACT_LOGIN_PHONE_INPUT_ID,
                        className: classnames_default()((CompactPhoneNumberField_module_default()).phoneInput, variant === "bid" && (CompactPhoneNumberField_module_default()).phoneInputBid, (0,_define_property/* default */.Z)({}, (CompactPhoneNumberField_module_default()).phoneInputError, hasError && layout !== "inline")),
                        type: "tel",
                        inputMode: "numeric",
                        name: contant/* loginFormFieldNames.phoneNumber */.H8.phoneNumber,
                        value: phoneValue,
                        onChange: onChangePhoneNum,
                        onFocus: CompactPhoneNumberField_handleAuthFocus,
                        onBlur: formik.handleBlur,
                        placeholder: "98765 43210",
                        autoComplete: "tel-national"
                    })
                ]
            }),
            hasError && layout !== "inline" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (CompactPhoneNumberField_module_default()).fieldError,
                children: formik.errors.phoneNumber
            }) : null
        ]
    });
};
/* harmony default export */ var compact_auth_CompactPhoneNumberField = (CompactPhoneNumberField);

;// CONCATENATED MODULE: ./components/homepage-v2/compact-auth/compactAuth.types.ts

var COMPACT_AUTH_STEPS;
(function(COMPACT_AUTH_STEPS) {
    COMPACT_AUTH_STEPS["PHONE"] = "phone";
    COMPACT_AUTH_STEPS["OTP"] = "otp";
})(COMPACT_AUTH_STEPS || (COMPACT_AUTH_STEPS = {}));
function compactAuthStepToLoginFormStep(step) {
    switch(step){
        case COMPACT_AUTH_STEPS.PHONE:
            return contant/* LOGIN_FORM_STEPS.PHONE_NUMBER */.lW.PHONE_NUMBER;
        case COMPACT_AUTH_STEPS.OTP:
            return contant/* LOGIN_FORM_STEPS.OTP */.lW.OTP;
        default:
            return contant/* LOGIN_FORM_STEPS.PHONE_NUMBER */.lW.PHONE_NUMBER;
    }
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(63397);
// EXTERNAL MODULE: ../../node_modules/react-cookie/es6/useCookies.js + 1 modules
var useCookies = __webpack_require__(47004);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../core/dist/constants/index.js + 4 modules
var constants = __webpack_require__(94204);
// EXTERNAL MODULE: ../core/dist/_services/index.js + 6 modules
var _services = __webpack_require__(96122);
;// CONCATENATED MODULE: ./components/homepage-v2/compact-auth/useCompactAuthWebV2Tracking.ts





var _obj;
var COMPACT_AUTH_EVENT_MAP = (_obj = {}, (0,_define_property/* default */.Z)(_obj, event_names/* GA4EventNames.LOGIN_OR_SIGNUP_MODAL.get_otp_clicked */.wQ.LOGIN_OR_SIGNUP_MODAL.get_otp_clicked, event_names/* GA4EventNames.WEB_V2.get_otp_clicked */.wQ.WEB_V2.get_otp_clicked), (0,_define_property/* default */.Z)(_obj, event_names/* GA4EventNames.LOGIN_OR_SIGNUP_MODAL.otp_submit */.wQ.LOGIN_OR_SIGNUP_MODAL.otp_submit, event_names/* GA4EventNames.WEB_V2.otp_submit */.wQ.WEB_V2.otp_submit), (0,_define_property/* default */.Z)(_obj, event_names/* GA4EventNames.LOGIN_OR_SIGNUP_MODAL.user_signup */.wQ.LOGIN_OR_SIGNUP_MODAL.user_signup, event_names/* GA4EventNames.WEB_V2.user_signup */.wQ.WEB_V2.user_signup), (0,_define_property/* default */.Z)(_obj, event_names/* GA4EventNames.COMPANY_REGISTRATION.user_registered */.wQ.COMPANY_REGISTRATION.user_registered, event_names/* GA4EventNames.WEB_V2.user_registered */.wQ.WEB_V2.user_registered), _obj);
var SKIP_LEGACY_AUTH_EVENTS = new Set([
    event_names/* GA4EventNames.LOGIN_OR_SIGNUP_MODAL.user_login */.wQ.LOGIN_OR_SIGNUP_MODAL.user_login,
    event_names/* GA4EventNames.COMPANY_REGISTRATION.company_details_submitted */.wQ.COMPANY_REGISTRATION.company_details_submitted
]);
/** Maps compact auth login events to WEB_V2 onb_form funnel events. */ function useCompactAuthWebV2Tracking(phoneNum) {
    var sendGAandMoEngageEvent = (0,_services/* useEventTrackerService */.fQ)().sendGAandMoEngageEvent;
    return (0,react.useCallback)(function(name, data) {
        if (SKIP_LEGACY_AUTH_EVENTS.has(name)) {
            return;
        }
        var mappedName = COMPACT_AUTH_EVENT_MAP[name];
        if (!mappedName) {
            return;
        }
        sendGAandMoEngageEvent({
            name: mappedName,
            data: (0,_object_spread/* default */.Z)({
                source_screen: event_names/* WEB_V2_SOURCE_SCREENS.ONB_FORM */.ZM.ONB_FORM
            }, phoneNum != null ? {
                Number: phoneNum
            } : {}, data)
        });
    }, [
        phoneNum,
        sendGAandMoEngageEvent
    ]);
}

// EXTERNAL MODULE: ./components/login-form-new/validation/validationSchema.ts
var validationSchema = __webpack_require__(94942);
// EXTERNAL MODULE: ./components/login-form-new/hooks/useLatest.ts
var useLatest = __webpack_require__(98957);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./components/login-form-new/hooks/auth/buildLoginFormInitialValues.ts
var buildLoginFormInitialValues = __webpack_require__(98968);
;// CONCATENATED MODULE: ./components/homepage-v2/compact-auth/autoRegisterNewUser.ts






/** Registers a new user inline after OTP — used by compact posting/bidding flows (no company-name step). */ function autoRegisterNewUser(_) {
    return _autoRegisterNewUser.apply(this, arguments);
}
function _autoRegisterNewUser() {
    _autoRegisterNewUser = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var values, helpers, otpStatus, globalData, defaultPlaceId, defaultCompanyName, defaultServiceType, phoneNum, onSubmitCompanyDetails, handleEventTracking, completeNewUserRegistration, companyName, serviceType, currentPlaceID, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    values = param.values, helpers = param.helpers, otpStatus = param.otpStatus, globalData = param.globalData, defaultPlaceId = param.defaultPlaceId, defaultCompanyName = param.defaultCompanyName, defaultServiceType = param.defaultServiceType, phoneNum = param.phoneNum, onSubmitCompanyDetails = param.onSubmitCompanyDetails, handleEventTracking = param.handleEventTracking, completeNewUserRegistration = param.completeNewUserRegistration;
                    companyName = values.companyName || defaultCompanyName || "User".concat(String(values.phoneNumber).slice(-4));
                    serviceType = values.serviceType || defaultServiceType || "";
                    currentPlaceID = (0,buildLoginFormInitialValues/* resolveLoginFormPlaceId */.Y)(globalData, defaultPlaceId);
                    _ctx.next = 6;
                    return onSubmitCompanyDetails({
                        name: companyName,
                        userId: otpStatus.userId,
                        serviceType: serviceType,
                        placeId: currentPlaceID
                    });
                case 6:
                    result = _ctx.sent;
                    if (result) {
                        _ctx.next = 10;
                        break;
                    }
                    (0,auth/* setOtpFieldError */.jm)(helpers, "Unable to complete registration. Please try again.");
                    return _ctx.abrupt("return");
                case 10:
                    (0,auth/* trackNewUserSignupStarted */.w6)(handleEventTracking, result, phoneNum);
                    _ctx.next = 13;
                    return completeNewUserRegistration((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                        companyName: companyName,
                        serviceType: serviceType,
                        currentPlaceID: currentPlaceID
                    }), result);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _autoRegisterNewUser.apply(this, arguments);
}

;// CONCATENATED MODULE: ./components/homepage-v2/compact-auth/useCompactAuth.ts
















function handleCompactAuthStepSubmit(values, helpers, ctx) {
    return _handleCompactAuthStepSubmit.apply(this, arguments);
}
function _handleCompactAuthStepSubmit() {
    _handleCompactAuthStepSubmit = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, helpers, ctx) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = ctx.activeStep;
                    _ctx.next = _ctx.t0 === COMPACT_AUTH_STEPS.PHONE ? 3 : _ctx.t0 === COMPACT_AUTH_STEPS.OTP ? 6 : 9;
                    break;
                case 3:
                    _ctx.next = 5;
                    return (0,auth/* submitPhoneStep */.Nw)({
                        phoneNumber: values.phoneNumber,
                        whatsappUpdatesEnabled: values.whatsappUpdatesEnabled,
                        setPhoneNum: ctx.setPhoneNum,
                        onSubmitPhoneNum: ctx.onSubmitPhoneNum,
                        handleEventTracking: ctx.handleEventTracking,
                        onPhoneVerified: function() {
                            return ctx.transitionToStep(COMPACT_AUTH_STEPS.OTP);
                        }
                    });
                case 5:
                    return _ctx.abrupt("return");
                case 6:
                    _ctx.next = 8;
                    return (0,auth/* submitOtpStep */.lP)({
                        phoneNumber: values.phoneNumber,
                        otp: values.otp,
                        setShouldPreventLayoutSwitch: ctx.setShouldPreventLayoutSwitch,
                        onSubmitOtp: ctx.onSubmitOtp,
                        handleEventTracking: ctx.handleEventTracking,
                        guardRef: ctx.otpSubmitInFlightRef,
                        onInvalidOtp: function() {
                            return (0,auth/* setOtpFieldError */.jm)(helpers, "Please enter the right OTP");
                        },
                        onRegisteredUser: ctx.completeRegisteredUserLogin,
                        onNewUser: function(status) {
                            return autoRegisterNewUser({
                                values: values,
                                helpers: helpers,
                                otpStatus: status,
                                globalData: ctx.globalData,
                                defaultPlaceId: ctx.defaultPlaceId,
                                defaultCompanyName: ctx.defaultCompanyName,
                                defaultServiceType: ctx.registrationServiceType,
                                phoneNum: ctx.phoneNum,
                                onSubmitCompanyDetails: ctx.onSubmitCompanyDetails,
                                handleEventTracking: ctx.handleEventTracking,
                                completeNewUserRegistration: ctx.completeNewUserRegistration
                            });
                        }
                    });
                case 8:
                    return _ctx.abrupt("return");
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _handleCompactAuthStepSubmit.apply(this, arguments);
}
/** Auth flow shared by the compact load posting and compact bidding modals (phone -> OTP -> auto-register). */ function useCompactAuth(config) {
    var onComplete = config.onComplete, onStepChange = config.onStepChange, _sourceScreen = config.sourceScreen, sourceScreen = _sourceScreen === void 0 ? constants/* WEB_V2_SOURCE_SCREENS.ONB_FORM */.ZMV.ONB_FORM : _sourceScreen, _isInitiatedFrom = config.isInitiatedFrom, isInitiatedFrom = _isInitiatedFrom === void 0 ? "Homepage V2 Compact Posting" : _isInitiatedFrom, defaultPlaceId = config.defaultPlaceId, defaultCompanyName = config.defaultCompanyName, registrationServiceType = config.registrationServiceType;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), phoneNum = ref.phoneNum, referralCode = ref.referralCode, globalData = ref.globalData, setGlobalData = ref.setGlobalData, setPhoneNum = ref.setPhoneNum, setReferralCode = ref.setReferralCode, setShouldPreventLayoutSwitch = ref.setShouldPreventLayoutSwitch;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([]), 2), setCookie = ref1[1];
    var router = (0,next_router.useRouter)();
    var otpSubmitInFlightRef = (0,react.useRef)(false);
    var onCompleteRef = (0,useLatest/* useLatest */.d)(onComplete);
    var ref2 = (0,auth/* useLoginStepTransition */.oy)({
        initialStep: COMPACT_AUTH_STEPS.PHONE,
        onStepChange: onStepChange
    }), activeStep = ref2.activeStep, animation = ref2.animation, transitionToStep = ref2.transitionToStep;
    var activeStepRef = (0,useLatest/* useLatest */.d)(activeStep);
    var handleEventTracking = useCompactAuthWebV2Tracking(phoneNum);
    var finishAuth = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(status) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setShouldPreventLayoutSwitch === null || setShouldPreventLayoutSwitch === void 0 ? void 0 : setShouldPreventLayoutSwitch(true);
                        _ctx.next = 3;
                        return onCompleteRef.current(status);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function finishAuth(status) {
            return _ref.apply(this, arguments);
        };
    }();
    var completeRegisteredUserLogin = (0,auth/* createRegisteredUserLoginHandler */.YO)({
        handleEventTracking: handleEventTracking,
        globalData: globalData,
        setGlobalData: setGlobalData,
        onComplete: finishAuth
    });
    var completeNewUserRegistration = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, result) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,auth/* processNewUserRegistration */.g8)({
                            values: values,
                            result: result,
                            handleEventTracking: handleEventTracking,
                            router: router,
                            setCookie: setCookie,
                            setReferralCode: setReferralCode,
                            setShouldPreventLayoutSwitch: setShouldPreventLayoutSwitch,
                            onSuccess: function(_values, result) {
                                return finishAuth(result);
                            }
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function completeNewUserRegistration(values, result) {
            return _ref.apply(this, arguments);
        };
    }();
    var submitContextRef = (0,react.useRef)({
        activeStep: activeStep,
        defaultPlaceId: defaultPlaceId,
        globalData: globalData,
        defaultCompanyName: defaultCompanyName,
        registrationServiceType: registrationServiceType,
        otpSubmitInFlightRef: otpSubmitInFlightRef,
        onSubmitPhoneNum: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        onSubmitOtp: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", undefined);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        onSubmitCompanyDetails: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", undefined);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        completeRegisteredUserLogin: completeRegisteredUserLogin,
        completeNewUserRegistration: completeNewUserRegistration,
        handleEventTracking: handleEventTracking,
        setPhoneNum: setPhoneNum,
        setShouldPreventLayoutSwitch: setShouldPreventLayoutSwitch,
        transitionToStep: transitionToStep,
        phoneNum: phoneNum
    });
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: (0,auth/* buildLoginFormInitialValues */.Be)({
            phoneNum: phoneNum,
            referralCode: referralCode,
            globalData: globalData,
            defaultPlaceId: defaultPlaceId,
            defaultServiceType: registrationServiceType
        }),
        validate: function(values) {
            return (0,validationSchema/* validateLoginFormValuesForStep */.V)(values, compactAuthStepToLoginFormStep(activeStepRef.current));
        },
        validateOnChange: true,
        validateOnMount: true,
        validateOnBlur: true,
        enableReinitialize: true,
        onSubmit: function(values, helpers) {
            return handleCompactAuthStepSubmit(values, helpers, submitContextRef.current);
        }
    });
    (0,react.useEffect)(function() {
        void formik.validateForm();
    }, [
        activeStep,
        formik.validateForm
    ]);
    var ref3 = (0,auth/* useLoginAuthBindings */.Px)({
        formik: formik,
        phoneNum: phoneNum,
        isInitiatedFrom: isInitiatedFrom,
        userJoiningBonusEnabled: false
    }), onSubmitPhoneNum = ref3.onSubmitPhoneNum, onClickResendOtp = ref3.onClickResendOtp, onSubmitOtp = ref3.onSubmitOtp, onSubmitCompanyDetails = ref3.onSubmitCompanyDetails;
    submitContextRef.current = {
        activeStep: activeStep,
        defaultPlaceId: defaultPlaceId,
        globalData: globalData,
        defaultCompanyName: defaultCompanyName,
        registrationServiceType: registrationServiceType,
        otpSubmitInFlightRef: otpSubmitInFlightRef,
        onSubmitPhoneNum: onSubmitPhoneNum,
        onSubmitOtp: onSubmitOtp,
        onSubmitCompanyDetails: onSubmitCompanyDetails,
        completeRegisteredUserLogin: completeRegisteredUserLogin,
        completeNewUserRegistration: completeNewUserRegistration,
        handleEventTracking: handleEventTracking,
        setPhoneNum: setPhoneNum,
        setShouldPreventLayoutSwitch: setShouldPreventLayoutSwitch,
        transitionToStep: transitionToStep,
        phoneNum: phoneNum
    };
    var onClickEditNumber = function() {
        formik.setFieldValue(contant/* loginFormFieldNames.otp */.H8.otp, "");
        formik.setFieldError(contant/* loginFormFieldNames.otp */.H8.otp, undefined);
        transitionToStep(COMPACT_AUTH_STEPS.PHONE);
    };
    return {
        formik: formik,
        activeStep: activeStep,
        animation: animation,
        onClickResendOtp: onClickResendOtp,
        onClickEditNumber: onClickEditNumber
    };
}

// EXTERNAL MODULE: ./components/homepage-v2/compact-auth/CompactLoginFlow.module.scss
var CompactLoginFlow_module = __webpack_require__(42217);
var CompactLoginFlow_module_default = /*#__PURE__*/__webpack_require__.n(CompactLoginFlow_module);
;// CONCATENATED MODULE: ./components/homepage-v2/compact-auth/CompactLoginFlow.tsx


















function CompactLoginQuoteSummary(param) {
    var amount = param.amount;
    var t = (0,useCompactLoadPostingTranslation/* default */.Z)().t;
    if (!amount) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CompactLoginFlow_module_default()).quoteSummary,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (CompactLoginFlow_module_default()).quoteLabel,
                children: t("load-form:login.yourQuote")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (CompactLoginFlow_module_default()).quoteValue,
                children: (0,methods/* getPriceString */.Bn)(amount)
            })
        ]
    });
}
var CompactLoginFlow = function(param) {
    var quoteAmount = param.quoteAmount, subtitle = param.subtitle, ctaLabels = param.ctaLabels, summarySlot = param.summarySlot, hideTerms = param.hideTerms, _phoneFieldVariant = param.phoneFieldVariant, phoneFieldVariant = _phoneFieldVariant === void 0 ? "default" : _phoneFieldVariant, _visualVariant = param.visualVariant, visualVariant = _visualVariant === void 0 ? "default" : _visualVariant, postingState = param.postingState, onComplete = param.onComplete, onStepChange = param.onStepChange, onShellBackRegister = param.onShellBackRegister, onShellFooterChange = param.onShellFooterChange, sourceScreen = param.sourceScreen, isInitiatedFrom = param.isInitiatedFrom, defaultPlaceId = param.defaultPlaceId, defaultCompanyName = param.defaultCompanyName, registrationServiceType = param.registrationServiceType, otpSentToKey = param.otpSentToKey, trackEvent = param.trackEvent;
    var ref, ref1;
    var t = (0,useCompactLoadPostingTranslation/* default */.Z)().t;
    var ref2 = (0,react.useContext)(app_context/* AppContext */.Il), companyId = ref2.companyId, customerCompanyId = ref2.customerCompanyId;
    var ref3 = useCompactAuth({
        onComplete: onComplete,
        onStepChange: onStepChange,
        sourceScreen: sourceScreen,
        isInitiatedFrom: isInitiatedFrom,
        defaultPlaceId: defaultPlaceId,
        defaultCompanyName: defaultCompanyName,
        registrationServiceType: registrationServiceType
    }), formik = ref3.formik, activeStep = ref3.activeStep, animation = ref3.animation, onClickResendOtp = ref3.onClickResendOtp, onClickEditNumber = ref3.onClickEditNumber;
    var isPosting = visualVariant === "posting";
    var sourcePlaceId = postingState === null || postingState === void 0 ? void 0 : (ref = postingState.source) === null || ref === void 0 ? void 0 : ref.place_id;
    var destinationPlaceId = postingState === null || postingState === void 0 ? void 0 : (ref1 = postingState.destination) === null || ref1 === void 0 ? void 0 : ref1.place_id;
    var lorryTypeId = postingState === null || postingState === void 0 ? void 0 : postingState.lorryType;
    var ref4 = (0,useGetLorryMarketV2/* useGetLorryMarketV2 */.r)({
        page: 1,
        l: 1,
        source_place_id: sourcePlaceId,
        destination_place_id: destinationPlaceId,
        c_i: customerCompanyId || companyId || undefined,
        lorry_type_id: lorryTypeId ? [
            lorryTypeId
        ] : undefined
    }, (0,_object_spread/* default */.Z)({
        enabled: isPosting && Boolean(sourcePlaceId && destinationPlaceId),
        refetchOnWindowFocus: false,
        retry: 0
    }, api/* NoSuccessErrorHandler */.jt)), lorryMarketData = ref4.data;
    var liveLorryCount = Number(lorryMarketData === null || lorryMarketData === void 0 ? void 0 : lorryMarketData.total_records) || 0;
    var showUrgencyStrip = isPosting && liveLorryCount > 0;
    (0,react.useEffect)(function() {
        if (!onShellBackRegister) {
            return;
        }
        onShellBackRegister(function() {
            if (activeStep === COMPACT_AUTH_STEPS.OTP) {
                onClickEditNumber();
                return true;
            }
            return false;
        });
        return function() {
            return onShellBackRegister(null);
        };
    }, [
        activeStep,
        onClickEditNumber,
        onShellBackRegister
    ]);
    /**
     * Send the OTP as soon as the number is complete — the field caps at 10 digits, so the
     * CTA adds a tap without adding a decision. Keyed on the number itself: a rejected send
     * is not retried on every render, and coming back via "change number" waits for an edit.
     */ var autoSubmittedPhoneRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var _phoneNumber;
        var phoneNumber = String((_phoneNumber = formik.values.phoneNumber) !== null && _phoneNumber !== void 0 ? _phoneNumber : "");
        if (activeStep !== COMPACT_AUTH_STEPS.PHONE || phoneNumber.length !== auth/* LOGIN_PHONE_NUMBER_LENGTH */.kE || !formik.isValid || formik.isSubmitting || autoSubmittedPhoneRef.current === phoneNumber) {
            return;
        }
        autoSubmittedPhoneRef.current = phoneNumber;
        void formik.submitForm();
    }, [
        activeStep,
        formik
    ]);
    var resolvedSummary = summarySlot !== null && summarySlot !== void 0 ? summarySlot : quoteAmount ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompactLoginQuoteSummary, {
        amount: quoteAmount
    }) : null;
    var showTerms = !hideTerms && (isPosting ? [
        COMPACT_AUTH_STEPS.PHONE,
        COMPACT_AUTH_STEPS.OTP
    ].includes(activeStep) : activeStep === COMPACT_AUTH_STEPS.PHONE);
    var urgencyStrip = showUrgencyStrip ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CompactLoginFlow_module_default()).urgencyStrip,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (CompactLoginFlow_module_default()).liveDot,
                "aria-hidden": true
            }),
            t("load-form:login.urgencyStrip", {
                count: liveLorryCount
            })
        ]
    }) : null;
    var getCtaLabel = function() {
        if (activeStep === COMPACT_AUTH_STEPS.PHONE) {
            var ref, ref1;
            return (ref1 = (ref = ctaLabels === null || ctaLabels === void 0 ? void 0 : ctaLabels.sendOtp) !== null && ref !== void 0 ? ref : t("load-form:login.sendOtp")) !== null && ref1 !== void 0 ? ref1 : "";
        }
        if (activeStep === COMPACT_AUTH_STEPS.OTP) {
            var ref2, ref3;
            return (ref3 = (ref2 = ctaLabels === null || ctaLabels === void 0 ? void 0 : ctaLabels.verify) !== null && ref2 !== void 0 ? ref2 : t("load-form:login.verifyAndContinue")) !== null && ref3 !== void 0 ? ref3 : "";
        }
        var ref4;
        return (ref4 = t("load-form:login.continue")) !== null && ref4 !== void 0 ? ref4 : "";
    };
    var renderStep = function() {
        switch(activeStep){
            case COMPACT_AUTH_STEPS.PHONE:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !isPosting && subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (CompactLoginFlow_module_default()).subtitle,
                            children: subtitle
                        }) : null,
                        urgencyStrip,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(compact_auth_CompactPhoneNumberField, {
                            formik: formik,
                            variant: phoneFieldVariant,
                            layout: isPosting ? "inline" : "default",
                            trackEvent: trackEvent
                        }),
                        !isPosting && resolvedSummary ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CompactLoginFlow_module_default()).summarySlot,
                            children: resolvedSummary
                        }) : null
                    ]
                });
            case COMPACT_AUTH_STEPS.OTP:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        urgencyStrip,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(compact_auth_CompactOtpField, {
                            formik: formik,
                            onClickResendOtp: onClickResendOtp,
                            onClickEditNumber: onClickEditNumber,
                            otpSentToKey: otpSentToKey,
                            compactBoxes: isPosting,
                            trackEvent: trackEvent
                        })
                    ]
                });
            default:
                return null;
        }
    };
    var showCta = [
        COMPACT_AUTH_STEPS.PHONE,
        COMPACT_AUTH_STEPS.OTP
    ].includes(activeStep);
    var useShellFooter = isPosting && Boolean(onShellFooterChange);
    (0,react.useEffect)(function() {
        if (!useShellFooter || !onShellFooterChange) {
            return;
        }
        if (!showCta) {
            onShellFooterChange(null);
            return;
        }
        onShellFooterChange({
            ctaLabel: getCtaLabel(),
            ctaDisabled: !formik.isValid || formik.isSubmitting,
            onCtaClick: function() {
                formik.submitForm();
            }
        });
        return function() {
            return onShellFooterChange(null);
        };
    }, [
        activeStep,
        ctaLabels === null || ctaLabels === void 0 ? void 0 : ctaLabels.sendOtp,
        ctaLabels === null || ctaLabels === void 0 ? void 0 : ctaLabels.verify,
        formik.isSubmitting,
        formik.isValid,
        onShellFooterChange,
        showCta,
        t,
        useShellFooter
    ]);
    var terms = showTerms ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: (CompactLoginFlow_module_default()).terms,
        children: [
            t("load-form:login.termsPrefix"),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/terms-and-conditions",
                className: (CompactLoginFlow_module_default()).termsLink,
                target: "_blank",
                rel: "noopener noreferrer",
                children: t("load-form:login.termsLink")
            }),
            " ",
            t("load-form:login.termsJoiner"),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/privacy-policy",
                className: (CompactLoginFlow_module_default()).termsLink,
                target: "_blank",
                rel: "noopener noreferrer",
                children: t("load-form:login.privacyLink")
            }),
            " ",
            t("load-form:login.termsSuffix")
        ]
    }) : null;
    var cta = showCta ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        type: "submit",
        className: (CompactLoginFlow_module_default()).cta,
        disabled: !formik.isValid || formik.isSubmitting,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: getCtaLabel()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_white/* default */.Z, {
                width: 16,
                height: 16,
                "aria-hidden": true
            })
        ]
    }) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((CompactLoginFlow_module_default()).flow, isPosting && (CompactLoginFlow_module_default()).flowPosting, useShellFooter && (CompactLoginFlow_module_default()).flowPostingShellFooter),
        children: [
            isPosting && postingState ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadSummaryChip/* default */.Z, {
                state: postingState,
                variant: "bodyStacked",
                showLoadingTime: true,
                includeVehicleDetails: true
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: classnames_default()(isPosting && (CompactLoginFlow_module_default()).postingForm, useShellFooter && (CompactLoginFlow_module_default()).postingFormShellFooter),
                onSubmit: function(e) {
                    e.preventDefault();
                    formik.submitForm();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(isPosting && (CompactLoginFlow_module_default()).postingBody, useShellFooter && (CompactLoginFlow_module_default()).postingBodyShellFooter),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimateContainer/* default */.Z, {
                                animation: animation,
                                children: renderStep()
                            }),
                            isPosting ? terms : null,
                            !isPosting ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    cta,
                                    terms
                                ]
                            }) : null
                        ]
                    }),
                    isPosting && !useShellFooter ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CompactLoginFlow_module_default()).postingFooter,
                        children: cta
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var compact_auth_CompactLoginFlow = (CompactLoginFlow);

;// CONCATENATED MODULE: ./components/homepage-v2/compact-auth/getCompactAuthShellMeta.ts

/** Shared header copy (step label + title) for the login step, reused by both the compact posting and bidding shells. */ function getCompactAuthShellMeta(loginStep, totalSteps, translate, keys) {
    var loginStepIndex = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 2;
    var stepLabel = translate(keys.stepLabelKey, {
        current: loginStepIndex,
        total: totalSteps
    });
    switch(loginStep){
        case COMPACT_AUTH_STEPS.OTP:
            return {
                stepLabel: stepLabel,
                title: translate(keys.otpTitleKey)
            };
        case COMPACT_AUTH_STEPS.PHONE:
        default:
            return {
                stepLabel: stepLabel,
                title: translate(keys.phoneTitleKey)
            };
    }
}

;// CONCATENATED MODULE: ./components/homepage-v2/compact-auth/index.ts







/***/ }),

/***/ 65178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ COMPACT_LOAD_BIDDING_STEPS; }
/* harmony export */ });
var COMPACT_LOAD_BIDDING_STEPS;
(function(COMPACT_LOAD_BIDDING_STEPS) {
    COMPACT_LOAD_BIDDING_STEPS["BID_DETAILS"] = "bidDetails";
    COMPACT_LOAD_BIDDING_STEPS["LOGIN"] = "login";
    COMPACT_LOAD_BIDDING_STEPS["SUCCESS"] = "success";
    COMPACT_LOAD_BIDDING_STEPS["ERROR"] = "error";
})(COMPACT_LOAD_BIDDING_STEPS || (COMPACT_LOAD_BIDDING_STEPS = {}));


/***/ }),

/***/ 72892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ compact_load_posting_LoadSummaryChip; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../core/dist/icons/arrow-right.svg
var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrowRight(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14.828,
    viewBox: "0 0 14 14.828"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".arrow-right_svg__arrow-right_b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/react.createElement("path", {
    className: "arrow-right_svg__arrow-right_b",
    d: "M1 7.414h12M7 1.414l6 6-6 6"
  }))));
}

/* harmony default export */ var arrow_right = (SvgArrowRight);
// EXTERNAL MODULE: ../core-ui/dist/methods/index.js + 3 modules
var methods = __webpack_require__(38920);
// EXTERNAL MODULE: ./components/homepage-v2/compact-load-posting/hooks/useCompactLoadPostingTranslation.ts
var useCompactLoadPostingTranslation = __webpack_require__(62921);
// EXTERNAL MODULE: ./components/homepage-v2/load-quote/index.ts + 1 modules
var load_quote = __webpack_require__(20380);
// EXTERNAL MODULE: ./components/homepage-v2/compact-load-posting/buildCompactLoadSpecParts.ts
var buildCompactLoadSpecParts = __webpack_require__(93653);
// EXTERNAL MODULE: ./components/homepage-v2/compact-load-posting/LoadSummaryChip.module.scss
var LoadSummaryChip_module = __webpack_require__(66980);
var LoadSummaryChip_module_default = /*#__PURE__*/__webpack_require__.n(LoadSummaryChip_module);
;// CONCATENATED MODULE: ./components/homepage-v2/compact-load-posting/LoadSummaryChip.tsx








var LoadSummaryChip = function(param) {
    var state = param.state, showLoadingTime = param.showLoadingTime, _variant = param.variant, variant = _variant === void 0 ? "hero" : _variant, includeVehicleDetails = param.includeVehicleDetails;
    var t = (0,useCompactLoadPostingTranslation/* default */.Z)().t;
    var isBodyChip = variant === "body";
    var resolvedIncludeDetails = includeVehicleDetails !== null && includeVehicleDetails !== void 0 ? includeVehicleDetails : isBodyChip ? false : variant === "bodyStacked" ? true : true;
    var specParts = (0,react.useMemo)(function() {
        return (0,buildCompactLoadSpecParts/* buildCompactLoadSpecParts */.wm)(state, {
            includeVehicleDetails: resolvedIncludeDetails,
            // Load Details body chip matches mockup: route + vehicle type only (e.g. LCV).
            includeCapacity: !isBodyChip,
            t: t
        });
    }, [
        isBodyChip,
        resolvedIncludeDetails,
        state,
        t
    ]);
    var sourceLabel = (0,load_quote/* getPlaceCityLabel */.Cb)(state.source);
    var destLabel = (0,load_quote/* getPlaceCityLabel */.Cb)(state.destination);
    var loadingTimeLabel = showLoadingTime && state.loadingTimestamp ? (0,methods/* formatDate */.p6)(new Date(state.loadingTimestamp * 1000), "DD MMM YYYY, h:mm a") : "";
    if (variant === "body" || variant === "bodyStacked") {
        var route = /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (LoadSummaryChip_module_default()).bodyRoute,
            children: [
                sourceLabel,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (LoadSummaryChip_module_default()).bodyArrow,
                    "aria-hidden": true,
                    children: [
                        " ",
                        "→",
                        " "
                    ]
                }),
                destLabel
            ]
        });
        var specs = specParts.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (LoadSummaryChip_module_default()).bodySpecs,
            children: specParts.map(function(part, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        index > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "aria-hidden": true,
                            children: " • "
                        }) : null,
                        part
                    ]
                }, "".concat(part, "-").concat(index));
            })
        }) : null;
        if (variant === "bodyStacked") {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LoadSummaryChip_module_default()).bodyStacked,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LoadSummaryChip_module_default()).top,
                        children: [
                            route,
                            specs
                        ]
                    }),
                    loadingTimeLabel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LoadSummaryChip_module_default()).timeRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                "aria-hidden": true,
                                children: "\uD83D\uDD52"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: loadingTimeLabel
                            })
                        ]
                    }) : null
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (LoadSummaryChip_module_default()).bodyChip,
            children: [
                route,
                specs
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((LoadSummaryChip_module_default()).chip, " ").concat(variant === "hero" ? (LoadSummaryChip_module_default()).chipHero : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (LoadSummaryChip_module_default()).city,
                        children: sourceLabel
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right, {
                        className: (LoadSummaryChip_module_default()).arrow,
                        width: 12,
                        height: 12,
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (LoadSummaryChip_module_default()).city,
                        children: destLabel
                    }),
                    specParts.map(function(part, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                index === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (LoadSummaryChip_module_default()).separator,
                                    children: "|"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (LoadSummaryChip_module_default()).dot,
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (LoadSummaryChip_module_default()).meta,
                                    children: part
                                })
                            ]
                        }, part);
                    })
                ]
            }),
            showLoadingTime && state.loadingTimestamp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (LoadSummaryChip_module_default()).loadingTime,
                children: t("load-form:loadDetails.loadingTimeSummary", {
                    time: (0,methods/* formatDate */.p6)(new Date(state.loadingTimestamp * 1000), "DD MMM YYYY, h:mm a")
                })
            }) : null
        ]
    });
};
/* harmony default export */ var compact_load_posting_LoadSummaryChip = (LoadSummaryChip);


/***/ }),

/***/ 93653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wm": function() { return /* binding */ buildCompactLoadSpecParts; }
/* harmony export */ });
/* unused harmony exports getLorryTypeLabel, getBodyTypeLabel */
/* harmony import */ var _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14345);
/* harmony import */ var _compactVehicleFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37876);


function getLorryTypeLabel(lorryTypeId) {
    var ref;
    if (!lorryTypeId) {
        return "";
    }
    var ref1;
    return (ref1 = (ref = (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .getVehicleInfoByLorryType */ .sB)(lorryTypeId, "load")) === null || ref === void 0 ? void 0 : ref.label) !== null && ref1 !== void 0 ? ref1 : "";
}
function getBodyTypeLabel(state) {
    var ref, ref1;
    if (!(0,_compactVehicleFields__WEBPACK_IMPORTED_MODULE_1__/* .isBodyTypeSelected */ .ml)(state.lorryBodyType) || !state.lorryType) {
        return undefined;
    }
    return (ref1 = (ref = (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .getVehicleInfoByLorryType */ .sB)(state.lorryType, "load")) === null || ref === void 0 ? void 0 : ref.bodyOptions.find(function(option) {
        return option.id === state.lorryBodyType;
    })) === null || ref1 === void 0 ? void 0 : ref1.name;
}
/** Shared spec line parts for LoadSummaryChip and CompactPostingSummaryCard. */ function buildCompactLoadSpecParts(state, param) {
    var _includeVehicleDetails = param.includeVehicleDetails, includeVehicleDetails = _includeVehicleDetails === void 0 ? true : _includeVehicleDetails, _includeCapacity = param.includeCapacity, includeCapacity = _includeCapacity === void 0 ? true : _includeCapacity, t = param.t;
    var lorryLabel = getLorryTypeLabel(state.lorryType);
    var capacityLabel = includeCapacity && state.tonnes ? "".concat(state.tonnes, " ").concat(Number(state.tonnes) > 1 ? t("mktCardV2:tonnes") : t("mktCardV2:tonne")) : undefined;
    var sizeLabel = includeVehicleDetails && (0,_compactVehicleFields__WEBPACK_IMPORTED_MODULE_1__/* .isCompactSizeSelected */ .D0)(state) ? state.sizeText ? "".concat(state.lorrySize, " ").concat(state.sizeText) : "".concat(state.lorrySize, " ").concat(t("mktCardV2:ft")) : undefined;
    var bodyTypeLabel = includeVehicleDetails ? getBodyTypeLabel(state) : undefined;
    return [
        lorryLabel,
        capacityLabel,
        sizeLabel,
        bodyTypeLabel
    ].filter(Boolean);
}


/***/ }),

/***/ 37876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D0": function() { return /* binding */ isCompactSizeSelected; },
/* harmony export */   "KF": function() { return /* binding */ resolveSizeFromFeetOptionId; },
/* harmony export */   "L8": function() { return /* binding */ isTyreSelected; },
/* harmony export */   "bM": function() { return /* binding */ getDefaultCompactSizeFields; },
/* harmony export */   "ml": function() { return /* binding */ isBodyTypeSelected; },
/* harmony export */   "uH": function() { return /* binding */ usesCapacityBasedSizeFlow; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14345);

/** Body type id can be 0 (e.g. Open) — must not use truthy checks. */ function isBodyTypeSelected(bodyType) {
    return bodyType != null;
}
function isTyreSelected(tyres) {
    return tyres != null && tyres > 0;
}
function isCompactSizeSelected(state) {
    return state.lorrySize != null && state.lorrySize > 0;
}
function usesCapacityBasedSizeFlow(lorryType) {
    return lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.CONTAINER */ .Sv.CONTAINER || lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.TRAILER */ .Sv.TRAILER || lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.LCV */ .Sv.LCV;
}
function getDefaultCompactSizeFields(lorryTypeId) {
    var vehicle = lorryTypeId ? (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .getVehicleInfoByLorryType */ .sB)(lorryTypeId, "load") : undefined;
    var firstOption = vehicle === null || vehicle === void 0 ? void 0 : vehicle.feetOptions[0];
    if (!firstOption) {
        return {
            lorrySize: 0,
            sizeText: "",
            lorrySizeNoPreference: false
        };
    }
    var _size, _sizeType;
    return {
        lorrySize: (_size = firstOption.size) !== null && _size !== void 0 ? _size : 0,
        sizeText: (_sizeType = firstOption.sizeType) !== null && _sizeType !== void 0 ? _sizeType : "",
        lorrySizeNoPreference: false
    };
}
function resolveSizeFromFeetOptionId(lorryTypeId, optionId) {
    var vehicle = lorryTypeId ? (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .getVehicleInfoByLorryType */ .sB)(lorryTypeId, "load") : undefined;
    var selected = vehicle === null || vehicle === void 0 ? void 0 : vehicle.feetOptions.find(function(item) {
        return item.id === optionId;
    });
    var ref, ref1;
    return {
        lorrySize: (ref = selected === null || selected === void 0 ? void 0 : selected.size) !== null && ref !== void 0 ? ref : 0,
        sizeText: (ref1 = selected === null || selected === void 0 ? void 0 : selected.sizeType) !== null && ref1 !== void 0 ? ref1 : "",
        lorrySizeNoPreference: false
    };
}


/***/ }),

/***/ 62921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useCompactLoadPostingTranslation */
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42386);

var COMPACT_LOAD_POSTING_NAMESPACES = [
    "load-form",
    "homepageV2",
    "common"
];
var useCompactLoadPostingTranslation = function() {
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)(COMPACT_LOAD_POSTING_NAMESPACES), t = ref.t, i18n = ref.i18n;
    return {
        t: t,
        i18n: i18n
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCompactLoadPostingTranslation);


/***/ }),

/***/ 77311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useCompactSheetRefAutoFocus; },
/* harmony export */   "v": function() { return /* binding */ useCompactSheetAutoFocus; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69849);
/* harmony import */ var _methods_homepageV2CompactSheet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14199);



function shouldSkipCompactSheetAutoFocus(enabled, hasFocused, hasTarget) {
    return !enabled || hasFocused || !hasTarget || (0,_methods_homepageV2CompactSheet__WEBPACK_IMPORTED_MODULE_2__/* .shouldDeferCompactSheetAutoFocusToUserTap */ .iZ)();
}
/** Deferred focus for an input located by element id inside a compact bottom sheet. */ function useCompactSheetAutoFocus(elementId) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _enabled = ref.enabled, enabled = _enabled === void 0 ? true : _enabled, _delay = ref.delay, delay = _delay === void 0 ? (0,_methods_homepageV2CompactSheet__WEBPACK_IMPORTED_MODULE_2__/* .getCompactSheetMountFocusDelayMs */ .gs)() : _delay, _scrollIntoView = ref.scrollIntoView, scrollIntoView = _scrollIntoView === void 0 ? true : _scrollIntoView;
    var hasFocusedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (shouldSkipCompactSheetAutoFocus(enabled, hasFocusedRef.current, Boolean(elementId))) {
            return;
        }
        hasFocusedRef.current = true;
        (0,_vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_1__/* .focusFormControl */ .zy)({
            candidateIds: [
                elementId
            ],
            delay: delay,
            scrollIntoView: scrollIntoView
        });
    }, [
        delay,
        elementId,
        enabled,
        scrollIntoView
    ]);
}
/** Deferred focus for the first matching input inside a container ref (OTP boxes, etc.). */ function useCompactSheetRefAutoFocus(containerRef) {
    var selector = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'input:not([type="hidden"])', ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _enabled = ref.enabled, enabled = _enabled === void 0 ? true : _enabled, _delay = ref.delay, delay = _delay === void 0 ? (0,_methods_homepageV2CompactSheet__WEBPACK_IMPORTED_MODULE_2__/* .getCompactSheetMountFocusDelayMs */ .gs)() : _delay, _scrollIntoView = ref.scrollIntoView, scrollIntoView = _scrollIntoView === void 0 ? true : _scrollIntoView;
    var hasFocusedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (shouldSkipCompactSheetAutoFocus(enabled, hasFocusedRef.current, true)) {
            return;
        }
        hasFocusedRef.current = true;
        var timer = window.setTimeout(function() {
            var ref;
            var focusTarget = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.querySelector(selector);
            if (!focusTarget) {
                hasFocusedRef.current = false;
                return;
            }
            (0,_vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_1__/* .focusKeyboardAware */ .lP)(focusTarget, {
                scrollIntoView: scrollIntoView
            });
        }, delay);
        return function() {
            return window.clearTimeout(timer);
        };
    }, [
        containerRef,
        delay,
        enabled,
        scrollIntoView,
        selector
    ]);
}


/***/ }),

/***/ 20380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "No": function() { return /* reexport */ getLoadQuoteCapacityNumber; },
  "U1": function() { return /* reexport */ getLoadQuoteCapacityStatus; },
  "Cb": function() { return /* reexport */ placeLabels/* getPlaceCityLabel */.Cb; },
  "lX": function() { return /* reexport */ parseLoadQuoteCapacity; }
});

// UNUSED EXPORTS: getLoadPostCapacityRangeText, getLoadQuoteCapacityRange, getLoadQuoteLorryOptionsForCapacity, getPlaceDescriptionLabel, isLoadQuoteCapacityBoundsReady, isLoadQuoteCapacityInRange

// EXTERNAL MODULE: ../core/dist/constants/lorryTypes.js
var lorryTypes = __webpack_require__(14345);
// EXTERNAL MODULE: ./methods/uiUtil.ts
var uiUtil = __webpack_require__(34695);
// EXTERNAL MODULE: ./methods/getLorryCapacityUnitLabel.ts
var getLorryCapacityUnitLabel = __webpack_require__(34363);
;// CONCATENATED MODULE: ./components/homepage-v2/load-quote/capacity.ts



function isLorryCompatibleWithCapacity(lorry, capacity) {
    return capacity >= lorry.capacity.min && capacity <= lorry.capacity.max;
}
function getLoadQuoteLorryOptionsForCapacity(capacity) {
    if (!Number.isFinite(capacity)) {
        return [];
    }
    return (0,lorryTypes/* getAllowedVehicleList */.UE)("load").filter(function(lorry) {
        return isLorryCompatibleWithCapacity(lorry, capacity);
    }).map(function(lorry) {
        return (0,uiUtil/* generateSelectOption */.Ow)(lorry.label, lorry.id, lorry.id);
    });
}
function getDefaultCapacityBounds() {
    var configuredBounds = lorryTypes/* NEW_LORRY_CAPACITY.LOAD_POST */.QZ.LOAD_POST;
    if (configuredBounds.max > 0) {
        return configuredBounds;
    }
    var lorries = (0,lorryTypes/* getAllowedVehicleList */.UE)("load");
    if (!lorries.length) {
        return configuredBounds;
    }
    return lorries.reduce(function(range, lorry) {
        return {
            min: Math.min(range.min, lorry.capacity.min),
            max: Math.max(range.max, lorry.capacity.max)
        };
    }, {
        min: Infinity,
        max: -Infinity
    });
}
function isLoadQuoteCapacityBoundsReady() {
    var ref = getDefaultCapacityBounds(), min = ref.min, max = ref.max;
    return max > min;
}
function getLoadPostCapacityRangeText() {
    var bounds = NEW_LORRY_CAPACITY.LOAD_POST;
    if (bounds.max > 0) {
        return "".concat(bounds.min, "-").concat(bounds.max, " T");
    }
    return undefined;
}
function getLoadQuoteCapacityRange(lorryTypeId) {
    var ref, ref1;
    var vehicle = lorryTypeId ? (0,lorryTypes/* getVehicleInfoByLorryType */.sB)(lorryTypeId, "load") : undefined;
    var defaultBounds = getDefaultCapacityBounds();
    var ref2;
    var min = (ref2 = vehicle === null || vehicle === void 0 ? void 0 : (ref = vehicle.capacity) === null || ref === void 0 ? void 0 : ref.min) !== null && ref2 !== void 0 ? ref2 : defaultBounds.min;
    var ref3;
    var max = (ref3 = vehicle === null || vehicle === void 0 ? void 0 : (ref1 = vehicle.capacity) === null || ref1 === void 0 ? void 0 : ref1.max) !== null && ref3 !== void 0 ? ref3 : defaultBounds.max;
    var unit = (0,getLorryCapacityUnitLabel/* getLorryCapacityUnitLabel */.z)(lorryTypeId);
    var ref4;
    var capacityText = (ref4 = vehicle === null || vehicle === void 0 ? void 0 : vehicle.capacityText) !== null && ref4 !== void 0 ? ref4 : "".concat(min, "-").concat(max, " ").concat(unit);
    return {
        min: min,
        max: max,
        capacityText: capacityText,
        unit: unit
    };
}
function isLoadQuoteCapacityInRange(capacity, lorryTypeId) {
    var ref = getLoadQuoteCapacityRange(lorryTypeId), min = ref.min, max = ref.max;
    return capacity >= min && capacity <= max;
}
function parseLoadQuoteCapacity(value) {
    if (!(value === null || value === void 0 ? void 0 : value.trim())) {
        return undefined;
    }
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}
/** Numeric capacity used in compact posting (API payload, validation). */ function getLoadQuoteCapacityNumber(tonnes) {
    var ref;
    return (ref = parseLoadQuoteCapacity(tonnes)) !== null && ref !== void 0 ? ref : 0;
}
function getLoadQuoteCapacityStatus(tonnes, isRemoteConfigLoaded) {
    var ref;
    var trimmed = (ref = tonnes === null || tonnes === void 0 ? void 0 : tonnes.trim()) !== null && ref !== void 0 ? ref : "";
    if (!trimmed) {
        return "empty";
    }
    var capacity = parseLoadQuoteCapacity(trimmed);
    if (capacity == null) {
        return "invalid";
    }
    if (!isRemoteConfigLoaded || !isLoadQuoteCapacityBoundsReady()) {
        return "pending";
    }
    if (!isLoadQuoteCapacityInRange(capacity)) {
        return "out_of_range";
    }
    if (!getLoadQuoteLorryOptionsForCapacity(capacity).length) {
        return "unsupported";
    }
    return "valid";
}

// EXTERNAL MODULE: ./components/homepage-v2/load-quote/placeLabels.ts
var placeLabels = __webpack_require__(2451);
;// CONCATENATED MODULE: ./components/homepage-v2/load-quote/index.ts




/***/ }),

/***/ 2451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$$": function() { return /* binding */ getPlaceDescriptionLabel; },
/* harmony export */   "Cb": function() { return /* binding */ getPlaceCityLabel; },
/* harmony export */   "zt": function() { return /* binding */ getPlaceStateLabel; }
/* harmony export */ });
/* unused harmony export getCityFromAddress */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87394);

function getCityFromAddress(address) {
    if (!(address === null || address === void 0 ? void 0 : address.trim())) {
        return "";
    }
    var parts = address.split(",").map(function(part) {
        return part.trim();
    }).filter(Boolean);
    if (parts.length === 0) {
        return "";
    }
    if (parts.length === 1) {
        return parts[0];
    }
    // Indian formatted addresses usually end with: ..., City, State PIN
    return parts[parts.length - 2] || parts[0];
}
function getPlaceCityState(place) {
    var ref;
    if (!place) {
        return {
            city: "",
            state: ""
        };
    }
    if ((ref = place.city) === null || ref === void 0 ? void 0 : ref.trim()) {
        var ref1;
        return {
            city: place.city.trim(),
            state: ((ref1 = place.state) === null || ref1 === void 0 ? void 0 : ref1.trim()) || ""
        };
    }
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((place.description || "").split(",").map(function(part) {
        return part.trim();
    }).filter(Boolean), 2), tmp = ref2[0], city = tmp === void 0 ? "" : tmp, tmp1 = ref2[1], state = tmp1 === void 0 ? "" : tmp1;
    return {
        city: city,
        state: state
    };
}
/** Short city label for route chips and summaries. */ function getPlaceCityLabel(place) {
    var ref, ref1, ref2, ref3;
    if (!place) {
        return "";
    }
    if ((ref = place.city) === null || ref === void 0 ? void 0 : ref.trim()) {
        return place.city.trim();
    }
    if ((ref1 = place.description) === null || ref1 === void 0 ? void 0 : ref1.trim()) {
        var cityFromDescription = getCityFromAddress(place.description);
        if (cityFromDescription) {
            return cityFromDescription;
        }
    }
    return ((ref2 = place.locality) === null || ref2 === void 0 ? void 0 : ref2.trim()) || ((ref3 = place.sub_locality) === null || ref3 === void 0 ? void 0 : ref3.trim()) || "";
}
/** State label from a place search result (city/state fields or parsed description). */ function getPlaceStateLabel(place) {
    return getPlaceCityState(place).state;
}
/** Full description for location search dropdown rows. */ function getPlaceDescriptionLabel(place) {
    var ref;
    if (!place) {
        return "";
    }
    if ((ref = place.description) === null || ref === void 0 ? void 0 : ref.trim()) {
        return place.description.trim();
    }
    var ref1 = getPlaceCityState(place), city = ref1.city, state = ref1.state;
    if (city && state) {
        return "".concat(city, ", ").concat(state);
    }
    return city || state;
}


/***/ }),

/***/ 14199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FY": function() { return /* binding */ getQuoteFormPickupToDropFocusDelayMs; },
/* harmony export */   "XQ": function() { return /* binding */ getQuoteFormLocationFieldConfig; },
/* harmony export */   "gs": function() { return /* binding */ getCompactSheetMountFocusDelayMs; },
/* harmony export */   "iZ": function() { return /* binding */ shouldDeferCompactSheetAutoFocusToUserTap; },
/* harmony export */   "mJ": function() { return /* binding */ createCompactSheetInputFocusHandler; },
/* harmony export */   "zq": function() { return /* reexport safe */ _vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__.Ck; }
/* harmony export */ });
/* unused harmony export COMPACT_SHEET */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42838);
/* harmony import */ var _vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69849);
/* harmony import */ var _vahak_core_ui_dist_methods_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82238);



/** Shared tuning for homepage v2 compact bottom-sheet flows (posting, bidding, auth). */ var COMPACT_SHEET = {
    MOUNT_FOCUS_DELAY_MS: 350,
    PICKUP_TO_DROP_FOCUS_DELAY_MS: 100,
    MENU_MAX_HEIGHT: 200,
    DESKTOP_MENU_MAX_HEIGHT: 300,
    /** Extra clearance above the field gap so auth inputs clear the sticky CTA. */ AUTH_STICKY_FOOTER_EXTRA_PX: 24
};

function getCompactSheetClearance(preset) {
    if (preset === "auth") {
        return (0,_vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__/* .getKeyboardViewportClearance */ .e5)(COMPACT_SHEET.AUTH_STICKY_FOOTER_EXTRA_PX);
    }
    return undefined;
}
/**
 * onFocus / focusin handler for compact-sheet inputs.
 * `keepInKeyboardView` runs after the keyboard settles and no-ops when the field already clears it.
 */ function createCompactSheetInputFocusHandler() {
    var preset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "field";
    return function(event) {
        if (!(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(event.target, Element)) {
            return;
        }
        (0,_vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__/* .keepInKeyboardView */ .uk)(event.target, {
            clearance: getCompactSheetClearance(preset)
        });
    };
}
function mobileQuoteFieldConfig(portalMenu) {
    var keyboardAware = (0,_vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__/* .needsKeyboardViewportCompensation */ .hP)();
    return {
        portalMenu: portalMenu,
        keyboardAware: keyboardAware,
        menuPlacement: "bottom",
        // Android native scroll; iOS uses JS scroll instead.
        menuShouldScrollIntoView: !keyboardAware,
        maxMenuHeight: COMPACT_SHEET.MENU_MAX_HEIGHT
    };
}
function getQuoteFormLocationFieldConfig(options) {
    var inSheet = options.inSheet, role = options.role, _isMobile = options.isMobile, isMobile = _isMobile === void 0 ? (0,_vahak_core_ui_dist_methods_browser__WEBPACK_IMPORTED_MODULE_2__/* .isMobileViewport */ .UM)() : _isMobile;
    if (!inSheet && !isMobile) {
        return {
            portalMenu: false,
            keyboardAware: false,
            menuPlacement: "bottom",
            menuShouldScrollIntoView: true,
            maxMenuHeight: COMPACT_SHEET.DESKTOP_MENU_MAX_HEIGHT
        };
    }
    // Drop in sheet: non-portaled menu stays anchored while the sheet scrolls (iOS).
    if (inSheet) {
        if (!isMobile) {
            return {
                portalMenu: true,
                keyboardAware: false,
                menuPlacement: "bottom",
                menuShouldScrollIntoView: true,
                maxMenuHeight: COMPACT_SHEET.DESKTOP_MENU_MAX_HEIGHT
            };
        }
        // Drop in mobile sheet: non-portaled menu stays anchored while the sheet scrolls (iOS).
        return mobileQuoteFieldConfig(role !== "drop");
    }
    return mobileQuoteFieldConfig(true);
}
function getCompactSheetMountFocusDelayMs() {
    return COMPACT_SHEET.MOUNT_FOCUS_DELAY_MS;
}
function getQuoteFormPickupToDropFocusDelayMs() {
    return COMPACT_SHEET.PICKUP_TO_DROP_FOCUS_DELAY_MS;
}
/**
 * Programmatic focus on sheet mount breaks the iOS keyboard (deep links).
 * Android can autofocus — leave that path open.
 */ function shouldDeferCompactSheetAutoFocusToUserTap() {
    return (0,_vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__/* .needsKeyboardViewportCompensation */ .hP)();
}


/***/ }),

/***/ 34363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getLorryCapacityUnitLabel; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94204);

var getLorryCapacityUnitLabel = function(lorryTypeId, quantity) {
    var lorryInfo = (0,_vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .getLorryDetailsByType */ .X9c)(lorryTypeId);
    if ((lorryInfo === null || lorryInfo === void 0 ? void 0 : lorryInfo.unit) === _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CAPACITY_UNIT_TYPES.TONNES */ .f5d.TONNES) {
        return quantity === 1 ? "Tonne" : "Tonnes";
    }
    return (lorryInfo === null || lorryInfo === void 0 ? void 0 : lorryInfo.unitSingular) || "Tonne";
};


/***/ }),

/***/ 42217:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"quoteSummary":"CompactLoginFlow_quoteSummary__Pq9Ep","quoteLabel":"CompactLoginFlow_quoteLabel__mRDcr","quoteValue":"CompactLoginFlow_quoteValue__2KsY9","flow":"CompactLoginFlow_flow__rVrw0","summarySlot":"CompactLoginFlow_summarySlot__zqQhW","subtitle":"CompactLoginFlow_subtitle__jyEqQ","cta":"CompactLoginFlow_cta__W6y6v","terms":"CompactLoginFlow_terms__CjNtf","termsLink":"CompactLoginFlow_termsLink__tx4Hi","flowPosting":"CompactLoginFlow_flowPosting__oFY4H","flowPostingShellFooter":"CompactLoginFlow_flowPostingShellFooter__Um_HU","urgencyStrip":"CompactLoginFlow_urgencyStrip__6vDbg","liveDot":"CompactLoginFlow_liveDot__NGAK2","hpv2PulseDot":"CompactLoginFlow_hpv2PulseDot__DCqI_","postingForm":"CompactLoginFlow_postingForm__YdDTH","postingFormShellFooter":"CompactLoginFlow_postingFormShellFooter__uN_IG","postingBody":"CompactLoginFlow_postingBody__xplrM","postingBodyShellFooter":"CompactLoginFlow_postingBodyShellFooter__r_5GI","postingFooter":"CompactLoginFlow_postingFooter__sRkDY","hpv2HeroSlideIn":"CompactLoginFlow_hpv2HeroSlideIn__a8Rw_","hpv2HeroFadeIn":"CompactLoginFlow_hpv2HeroFadeIn__Qq7OE","hpv2HeroFadeInOpacity":"CompactLoginFlow_hpv2HeroFadeInOpacity__fYAKF","hpv2FadeUp":"CompactLoginFlow_hpv2FadeUp__6_Y4L","hpv2FadeLeft":"CompactLoginFlow_hpv2FadeLeft__ZpwyC","hpv2FadeRight":"CompactLoginFlow_hpv2FadeRight__z7Waw","hpv2ScaleUp":"CompactLoginFlow_hpv2ScaleUp__WpsSE","hpv2Blink":"CompactLoginFlow_hpv2Blink__GGpyq","hpv2FloatA":"CompactLoginFlow_hpv2FloatA__VJCGK","hpv2FloatB":"CompactLoginFlow_hpv2FloatB__CL54C","hpv2DemoProgress":"CompactLoginFlow_hpv2DemoProgress__7K5Wu","hpv2DemoSlideIn":"CompactLoginFlow_hpv2DemoSlideIn__aE9pk","hpv2DemoFadeIn":"CompactLoginFlow_hpv2DemoFadeIn__vM8CL","hpv2DemoScaleIn":"CompactLoginFlow_hpv2DemoScaleIn__lBCqo","hpv2DemoBounce":"CompactLoginFlow_hpv2DemoBounce__ME306","hpv2PriceShimmer":"CompactLoginFlow_hpv2PriceShimmer__op_5A"};

/***/ }),

/***/ 77255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"field":"CompactOtpField_field__b6AlP","sentTo":"CompactOtpField_sentTo___ZHEz","phoneNumber":"CompactOtpField_phoneNumber__3F2ma","changeNumberBtn":"CompactOtpField_changeNumberBtn__vboFk","label":"CompactOtpField_label__rnjVG","otpContainer":"CompactOtpField_otpContainer__RG8ZJ","otpDigit":"CompactOtpField_otpDigit__HGCZW","otpDigitError":"CompactOtpField_otpDigitError__j2gKC","resendRow":"CompactOtpField_resendRow__fJPs5","resendTimer":"CompactOtpField_resendTimer__vdR7E","resendBtn":"CompactOtpField_resendBtn__qb_BU","fieldCompact":"CompactOtpField_fieldCompact__PcqNW","numberChip":"CompactOtpField_numberChip__mHKT7","numberChipValue":"CompactOtpField_numberChipValue__m9QRa"};

/***/ }),

/***/ 30518:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"field":"CompactPhoneNumberField_field__w72Xf","label":"CompactPhoneNumberField_label__Q79Ky","inputRow":"CompactPhoneNumberField_inputRow__e6du7","countryCode":"CompactPhoneNumberField_countryCode__WDhgS","countryCodeBid":"CompactPhoneNumberField_countryCodeBid__N2ch6","flag":"CompactPhoneNumberField_flag__qv2ht","dialCode":"CompactPhoneNumberField_dialCode__S9c_L","phoneInput":"CompactPhoneNumberField_phoneInput__CtKGj","phoneInputBid":"CompactPhoneNumberField_phoneInputBid__cVcDF","phoneInputError":"CompactPhoneNumberField_phoneInputError__faB_b","fieldError":"CompactPhoneNumberField_fieldError__Dfbay","fieldInline":"CompactPhoneNumberField_fieldInline__fhHm2","hpv2HeroSlideIn":"CompactPhoneNumberField_hpv2HeroSlideIn__slZ_q","hpv2HeroFadeIn":"CompactPhoneNumberField_hpv2HeroFadeIn__RGyp4","hpv2HeroFadeInOpacity":"CompactPhoneNumberField_hpv2HeroFadeInOpacity__Gd_gN","hpv2FadeUp":"CompactPhoneNumberField_hpv2FadeUp__8zpik","hpv2FadeLeft":"CompactPhoneNumberField_hpv2FadeLeft__J9HlB","hpv2FadeRight":"CompactPhoneNumberField_hpv2FadeRight__NFSJz","hpv2ScaleUp":"CompactPhoneNumberField_hpv2ScaleUp__ITbCx","hpv2Blink":"CompactPhoneNumberField_hpv2Blink__tfi_y","hpv2FloatA":"CompactPhoneNumberField_hpv2FloatA__d6m7O","hpv2FloatB":"CompactPhoneNumberField_hpv2FloatB__V_PSy","hpv2DemoProgress":"CompactPhoneNumberField_hpv2DemoProgress__C8R49","hpv2DemoSlideIn":"CompactPhoneNumberField_hpv2DemoSlideIn__66q4x","hpv2DemoFadeIn":"CompactPhoneNumberField_hpv2DemoFadeIn__I65Uv","hpv2DemoScaleIn":"CompactPhoneNumberField_hpv2DemoScaleIn__mbUHW","hpv2DemoBounce":"CompactPhoneNumberField_hpv2DemoBounce__Uf2MH","hpv2PulseDot":"CompactPhoneNumberField_hpv2PulseDot__XaGm8","hpv2PriceShimmer":"CompactPhoneNumberField_hpv2PriceShimmer__wImXe"};

/***/ }),

/***/ 66980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"chip":"LoadSummaryChip_chip__4ucmS","city":"LoadSummaryChip_city__Ecdu_","meta":"LoadSummaryChip_meta__muCH_","dot":"LoadSummaryChip_dot__RBl63","separator":"LoadSummaryChip_separator__MnMKe","arrow":"LoadSummaryChip_arrow__kikcq","chipHero":"LoadSummaryChip_chipHero__qrcsB","loadingTime":"LoadSummaryChip_loadingTime__hHktu","bodyChip":"LoadSummaryChip_bodyChip__Hvos_","bodyStacked":"LoadSummaryChip_bodyStacked__zUvEk","top":"LoadSummaryChip_top__il209","timeRow":"LoadSummaryChip_timeRow__3BPgB","bodyRoute":"LoadSummaryChip_bodyRoute__J4G45","bodyArrow":"LoadSummaryChip_bodyArrow__Holbe","bodySpecs":"LoadSummaryChip_bodySpecs___DfV4","hpv2HeroSlideIn":"LoadSummaryChip_hpv2HeroSlideIn__q_u_u","hpv2HeroFadeIn":"LoadSummaryChip_hpv2HeroFadeIn__gfaFI","hpv2HeroFadeInOpacity":"LoadSummaryChip_hpv2HeroFadeInOpacity____TR3","hpv2FadeUp":"LoadSummaryChip_hpv2FadeUp__lILHR","hpv2FadeLeft":"LoadSummaryChip_hpv2FadeLeft__j_pZu","hpv2FadeRight":"LoadSummaryChip_hpv2FadeRight__jJJcu","hpv2ScaleUp":"LoadSummaryChip_hpv2ScaleUp__XQkE_","hpv2Blink":"LoadSummaryChip_hpv2Blink__3o8Vz","hpv2FloatA":"LoadSummaryChip_hpv2FloatA__Gyuug","hpv2FloatB":"LoadSummaryChip_hpv2FloatB__bXBkX","hpv2DemoProgress":"LoadSummaryChip_hpv2DemoProgress__biGZ_","hpv2DemoSlideIn":"LoadSummaryChip_hpv2DemoSlideIn___QxEE","hpv2DemoFadeIn":"LoadSummaryChip_hpv2DemoFadeIn__i9_6c","hpv2DemoScaleIn":"LoadSummaryChip_hpv2DemoScaleIn__BWgEN","hpv2DemoBounce":"LoadSummaryChip_hpv2DemoBounce__eyPFc","hpv2PulseDot":"LoadSummaryChip_hpv2PulseDot__nFwsx","hpv2PriceShimmer":"LoadSummaryChip_hpv2PriceShimmer__zqPE7"};

/***/ }),

/***/ 42838:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

}]);